export default function () {
  var windowOffset = $(window).scrollTop();
  var viewPort = 0.8;
  $(".lazyload").each(function () {
    if ($(this).offset().top <= windowOffset + $(window).height() * viewPort) {
      $(this)
        .attr("srcset", $(this).data("srcset"))
        .addClass("lazyloaded")
        .removeClass("lazyload");
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/util/lazyload.js